export const sectionBg = 'rgba(0,0,0,0.03)';
export const wpBg = '#f1f1f1';
